import BaseAPI from "../api";

const path: string = "/log-user";

export type listType = {
  leave_status?: string;
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  keyword?: number;
  limit?: number;
  page?: number;
  start_date?: string;
  end_date?: string;
  search?: string;
  id_faculty?: string
  log_user_type?: string
};

export class LogUserApi extends BaseAPI {
  static getHistoryList(query: listType): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }
  static getThesisBookList(query: any): Promise<any> {
    return this.api.get(`${path}/thesis-book`, {
      params: { ...query },
    });
  }
}
